module.exports = __webpack_public_path__ + "img/bubble-checkmark.95f96edb.svg";